// Phase 85.A.63 — Pending Payment Storage (localStorage)
//
// Khi VĐV đăng ký giải đến Bước 4 (Thanh toán) và backend đã tạo `reg`
// status=draft + `payment_order` chờ SePay, ta lưu lại marker vào
// localStorage để nếu user lỡ tay tắt trình duyệt / crash giữa chừng,
// lần sau quay lại app có thể auto-redirect về Bước 4 và tiếp tục thao
// tác. User choice (qua ask_human Phase 85.A.63):
//   • Chỉ xử lý đăng ký pending mới nhất (single key).
//   • Không auto timeout — admin tự xử lý.
//   • Lưu localStorage thuần (mất khi clear cache — chấp nhận trade-off
//     vì backend vẫn giữ pending reg trong DB).
//
// Marker được CLEAR trong 3 trường hợp:
//   1. SePay webhook xác nhận paid (polling phát hiện status=paid).
//   2. User bấm "Huỷ tham gia" trong modal cảnh báo.
//   3. Backend trả 404 / cancelled khi resume (defensive).

const KEY = "pickleague:pending_payment_v1";

export function readPendingPayment() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    // Sanity check fields
    if (!parsed.tournament_slug || !parsed.event_id || !parsed.reg_id) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function writePendingPayment({
  tournamentSlug,
  tournamentId,
  eventId,
  regId,
  inviteId = null,
}) {
  if (!tournamentSlug && !tournamentId) return;
  if (!eventId || !regId) return;
  try {
    const payload = {
      tournament_slug: tournamentSlug || tournamentId,
      tournament_id: tournamentId || null,
      event_id: eventId,
      reg_id: regId,
      invite_id: inviteId || null,
      saved_at: new Date().toISOString(),
    };
    window.localStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* localStorage quota / disabled — silently ignore */
  }
}

export function clearPendingPayment() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export const PENDING_PAYMENT_STORAGE_KEY = KEY;
